"use client";

import { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { textColorSecondary, accentColorDanger } from "@churchofjesuschrist/eden-style-constants";
import { ValidityStateContext } from "../utils/context";
import { Text5 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
const colorsByValidityState = {
  error: accentColorDanger
};
export const InternalUseOnlyHint = styled(Text5).withConfig({
  componentId: "sc-12eqlx9-0"
})(["display:block;color:", ";"], _ref => {
  let {
    $validityState
  } = _ref;
  return colorsByValidityState[$validityState] || textColorSecondary;
});

/**
 * The Hint provides a user with helper information about the control it is paired with.
 */
const Hint = _ref2 => {
  let {
    children,
    ...props
  } = _ref2;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/_jsx(InternalUseOnlyHint, {
    renderAs: "span",
    $validityState: validityStateContext,
    ...props,
    children: children
  });
};
Hint.displayName = "Hint";
Hint.propTypes = {
  /** Content to render inside the Hint Component */
  children: PropTypes.node
};
export default Hint;